export const CARET_ICON_NAME = 'fab-dropdown-caret-9x5';
